//  import { StatusBar, BackgroundColorOptions} from '@capacitor/status-bar';
/* tslint:disable */
import {
  Component,
  PLATFORM_ID,
  Inject,
  OnInit,
  AfterViewInit,
  NgZone,
  LOCALE_ID,
  HostListener,
  Renderer2,
  ElementRef,
  ViewChild,
  TemplateRef,
} from "@angular/core";
/**
 * use Location if current Router did not fit if you get current url
 */
import { formatDate, isPlatformBrowser, Location } from "@angular/common";
import { LoadingBarService } from "@ngx-loading-bar/core";
import { map, delay, withLatestFrom, mergeMap, switchMap, filter, take } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { Routes, Router, NavigationEnd, NavigationStart } from "@angular/router";
import { PwaServiceService } from './pwa-service.service';
import { NgbModal, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SignUpComponent } from '../app/pages/sign-up/sign-up.component';
import { SwUpdate } from '@angular/service-worker';
import { SplashScreen } from '@capacitor/splash-screen';
import { Capacitor } from '@capacitor/core';
import { DataService } from 'src/app/shared/services/data.service';
import { App } from '@capacitor/app';
import { callbackUri } from './auth.config';
import { AuthService } from "@auth0/auth0-angular";
import { Browser } from '@capacitor/browser';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NaviFreshMartService } from 'src/app/shared/services/navi-fresh-mart.service';
import { cart } from "./shared/classes/cart";
import { userprofile } from "./shared/classes/userprofile";
import { ActivatedRoute } from '@angular/router';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { BehaviorSubject } from "rxjs";
import {

  PushNotifications
} from '@capacitor/push-notifications';

import { environment } from './../environments/environment';
import { SwPush } from '@angular/service-worker';
import { FCM } from '@capacitor-community/fcm';
import { Device } from '@capacitor/device';
import { IosPwaService } from './shared/services/ios-pwa.service';
import { MatBottomSheet, MatBottomSheetModule, MatBottomSheetRef } from "@angular/material/bottom-sheet";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],

})
export class AppComponent implements OnInit, AfterViewInit {
  // For Progressbar
  loaders = this.loader.progress$.pipe(
    delay(1000),
    withLatestFrom(this.loader.progress$),
    map((v) => v[1])
  );
  userForm: FormGroup;
  loggeedUser$ = this.auth.isAuthenticated$.pipe(switchMap(() => this.auth.user$));
  machinesList = [];
  currentMessage = new BehaviorSubject<any>(null);
  webPush = environment.pushkeys;
  isInstallPrompt: boolean = false;
  private installPromiseResolve: ((value: boolean | PromiseLike<boolean>) => void) | null = null;
  qrcodeImg = "../assets/images/qr-code.svg";
  showScan: boolean = false;

  labelText: string = 'Scan here';
  scrollingTimer: number | null = null;

  accountId: string = "";
  @ViewChild('iosPromptTemplate') iosPromptTemplate!: TemplateRef<any>;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private loader: LoadingBarService,
    translate: TranslateService,
    public router: Router,
    // private location: Location
    public Pwa: PwaServiceService,
    private modalService: NgbModal, public activeModal: NgbActiveModal,
    private swUpdate: SwUpdate,
    private dataService: DataService,
    private auth: AuthService,
    private ngZone: NgZone,
    private naviService: NaviFreshMartService,
    private fireMessaging: AngularFireMessaging,
    private swPush: SwPush,
    @Inject(LOCALE_ID) public locale: string,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2, private el: ElementRef,
    private iosPwaService: IosPwaService,
    private _bottomSheet: MatBottomSheet
  ) {

    this.requestPushNotifications();
  }
  async ngAfterViewInit(): Promise<void> {
    const resp = await this.naviService.loadConfig();


    // console.log("app afterviewinit ",window.location);
  }

  async promptUserForInstall(): Promise<boolean> {
    this.isInstallPrompt = true;
    return new Promise<boolean>((resolve) => {
      this.installPromiseResolve = resolve;
    });

  }

  resolveInstallPromise(userAction: boolean) {
    if (this.installPromiseResolve) {
      this.installPromiseResolve(userAction);
      this.installPromiseResolve = null;
    }
    this.isInstallPrompt = false;

  }
  HideOrShowScan(isShow: boolean) {
    this.showScan = isShow;
    const iconDiv = this.el.nativeElement.querySelector('.icon-div');
    if (iconDiv) {
      if (this.showScan) {
        this.renderer.addClass(iconDiv, 'fadeInOut');
        setTimeout(() => {
          const scanText = this.el.nativeElement.querySelector('.scan-text');
          if (scanText) {
            this.renderer.addClass(scanText, 'textAnimation');
            this.renderer.addClass(iconDiv, 'width-180');
          }
        }, 1000);
      }
      else {
        this.renderer.removeClass(iconDiv, 'fadeInOut');
        setTimeout(() => {
          const scanText = this.el.nativeElement.querySelector('.scan-text');
          if (scanText) {
            this.renderer.removeClass(scanText, 'textAnimation');
            this.renderer.removeClass(iconDiv, 'width-180');
          }
        }, 1000);
      }

    }
  }
  async ngOnInit() {
    this.swUpdate.available.subscribe((event) => {
      console.log('New version available');
      if (confirm('Do you want to update to the latest version?')) {
        this.swUpdate.activateUpdate().then(() => document.location.reload());
      }
    });
    let promptEvent;
    if (!window.matchMedia('(display-mode: standalone)').matches) { // not pwa 
      this.iosPwaService.checkForiOS();
      window.addEventListener('beforeinstallprompt', e => {
        e.preventDefault();
        promptEvent = e;
        console.log("event", e);

      });
      window.addEventListener('click', async () => {
        // deferredPrompt is a global variable we've been using in the sample to capture the `beforeinstallevent`
        if (promptEvent) {
          promptEvent.prompt();
          // Find out whether the user confirmed the installation or not
          const { outcome } = await promptEvent.userChoice;
          // The deferredPrompt can only be used once.
          promptEvent = null;
          // Act on the user's choice
          if (outcome === 'accepted') {
            console.log('User accepted the install prompt.');
          } else if (outcome === 'dismissed') {
            console.log('User dismissed the install prompt');
          }
        }

      });
    }
    if (Capacitor.getPlatform() != "web") {

      // unique device Id for vending machines
      const deviceId = await Device.getId();

      console.log("deviceId", deviceId);
      console.log("uuid", deviceId.identifier);
      // alert("uuid"+deviceId.identifier);
      const resp = await this.naviService.loadConfig();
      const vendorId = this.naviService.getConfig().vendorId;
      this.naviService.getMachines(vendorId, this.accountId).subscribe((data) => {
        this.machinesList = data;

        console.log('machineslist', this.machinesList[0]);
        const endDate = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss', this.locale);
        console.log(endDate);
        const payload = {
          startDate: "2021-01-01 00:00:00",
          endDate: endDate
        }
        this.naviService.getUsersList(payload).subscribe((data) => {
          const usersList = data?.users;
          console.log('user', usersList[usersList?.length - 1].userName);
          const deviceObj = usersList.find(obj => obj.mobile == deviceId.identifier);
          console.log("deviceObj", deviceObj?.userName);
          if (deviceObj) {
            this.dataService.setIsSearchDisable(true);
            localStorage.setItem(
              'user',
              JSON.stringify({
                mobileNumber: deviceObj?.mobileNumber,
                accountId: deviceObj?.accountId,
                email: deviceObj?.email,
                userName: deviceObj?.userName,
                role: deviceObj?.role
              })
            );
            const name = deviceObj.userName;
            const genieIdArray = name.split("-");
            console.log("genieId", genieIdArray);
            console.log("genieId1", genieIdArray[1]);
            const genieId = genieIdArray[1];
            const stallObj = this.machinesList.find(stall => stall.stallid == genieId);

            localStorage.setItem("genieName", stallObj.name);
            localStorage.setItem('genieId', stallObj.stallid + "");
            this.dataService.UpdateGenieName(stallObj.name);
            this.dataService.setGenieStatus(stallObj.cloudStatus);
            localStorage.setItem('loginType', 'Genie');
            this.dataService.setMachineId(parseInt(genieId));
            this.router.navigate(['shop/machine-prod-items'])
          }
          else this.CheckingAuthentication();
        });
      })
    }
    else {
      this.CheckingAuthentication();
    }





    // Use Capacitor's App plugin to subscribe to the `appUrlOpen` event


  }

  installPWA(deferredPrompt) {
    console.log(deferredPrompt);
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        deferredPrompt = null;
      });
    }
  }
  async CheckingAuthentication() {
    if (Capacitor.getPlatform() == "web") {
      navigator.serviceWorker.addEventListener(
        'message',
        this.handleMessage.bind(this)
      );
    }

    const resp = await this.naviService.loadConfig();
    console.log("resp", resp);
    this.userForm = new FormGroup({
      mobileNumber: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{10}$')]),
      fName: new FormControl('', [Validators.required, Validators.minLength(5)]),
      email: new FormControl('', [Validators.required, Validators.email]),
      otp: new FormControl(),
    });
    const vendorId = this.naviService.getConfig().vendorId;
    this.naviService.getMachines(vendorId, this.accountId).subscribe((data) => {
      let machines = data;
      // this.machinesList = machines.filter(mach => mach.type === 'Genie');
      this.machinesList = machines;
      console.log('machineslist', this.machinesList);
      App.addListener('appUrlOpen', ({ url }) => {
        // Must run inside an NgZone for Angular to pick up the changes
        // https://capacitorjs.com/docs/guides/angular
        this.ngZone.run(() => {
          if (url?.startsWith(callbackUri)) {
            // If the URL is an authentication callback URL..
            if (
              url.includes('state=') &&
              (url.includes('error=') || url.includes('code='))
            ) {
              // Call handleRedirectCallback and close the browser
              this.auth
                .handleRedirectCallback(url)
                .pipe(mergeMap(() => Browser.close()))
                .subscribe();
            } else {
              Browser.close();
            }
          }
        });
      });




      this.requestFirebaseToken();
      this.getMessages();


      if (localStorage.getItem('user') && localStorage.getItem('loginType')) {
        if (this.router.url == "/") {
          if (localStorage.getItem('genieId')) {
            this.dataService.setMachineId(parseInt(localStorage.getItem('genieId')));
            this.dataService.setFooterActie('shop');
            this.router.navigate(['shop/machine-prod-items'])
          }
          else {
            this.router.navigate(['shop/mfg-land']);

          }

        }

      }
      else {
        if (this.router.url == "/") {
          this.router.navigate(['/landscreen']);
        }

      }
      // else this.router.navigate(['shop/mfg-land']);



    });





  }
  handleMessage(event: MessageEvent) {
    if (event.data && event.data.type === 'notification-click') {
      console.log('route', event.data.route);
      const route = event.data.route;
      if (route != '' && route != null) {
        console.log("route", route);
        this.router.navigateByUrl(`/${route}`,
        );
      }
      // Play audio

      // Display alert
    }
  }

  requestPushNotifications() {
    if (Capacitor.getPlatform() == 'android') {
      this.NotificationsForAndorid();
      //  this.requestFirebaseToken();
    }
    else {
      this.subscribeToNotifications();

    }
  }
  subscribeToNotifications() {
    console.log("testing requesting notifications", this.webPush.publicKey);
    this.swPush
      .requestSubscription({
        serverPublicKey: this.webPush.publicKey,
      })
      .then((sub) => {
        console.log('Subscribed to push', sub);
      })

      .catch((err) =>
        console.error('Could not subscribe to notifications', err)
      );
  }
  async NotificationsForAndorid() {
    const addListeners = async () => {
      await PushNotifications.addListener('registration', async token => {
        console.info('Registration token: ', token.value);
        let user = JSON.parse(localStorage.getItem('user'));
        let payload = {
          mobile: user.mobileNumber,
          token: token.value,
        };
        const tokeResp = await this.naviService.fetchRequestPost(
          'pushnotification/createtoken',
          payload
        );

        // alert(`Token ${token.value}`)
      });

      await PushNotifications.addListener('registrationError', err => {
        console.error('Registration error: ', err.error);
      });

      await PushNotifications.addListener('pushNotificationReceived', notification => {
        console.log('Push notification received: ', notification.title);

      });

      await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
        console.log('Push notification action performed', notification.actionId, notification.inputValue);
      });
    }

    const registerNotifications = async () => {
      let permStatus = await PushNotifications.checkPermissions();
      //  alert(permStatus.receive);
      //  alert(permStatus);
      if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions();
      }

      if (permStatus.receive !== 'granted') {
        throw new Error('User denied permissions!');
      }

      await PushNotifications.register();
    }

    const getDeliveredNotifications = async () => {
      const notificationList = await PushNotifications.getDeliveredNotifications();
      console.log('delivered notifications', notificationList);
    }
    await addListeners();
    await registerNotifications();
    await getDeliveredNotifications();
  }
  async requestFirebaseToken() {
    if (Capacitor.getPlatform() == "web") {
      this.fireMessaging.getToken.pipe(take(1)).subscribe(async (token: string | null) => {
        console.log('token', token);
        token;
        if (token) {
          let user = JSON.parse(localStorage.getItem('user'));
          let payload = {
            mobile: user.mobileNumber,
            token: token,
          };
          const tokeResp = await this.naviService.fetchRequestPost(
            'pushnotification/createtoken',
            payload
          );
        }

      },
        (err) => {
          console.log('unable to get permission', err);
        }
      );
    }



  }
  getMessages() {
    this.fireMessaging.messages.subscribe((message: any) => {
      console.log('new Message', message);
      console.log(message.notification);
      alert(message.notification.title);
      // navigator.serviceWorker
      //     .getRegistration('/firebase-cloud-messaging-push-scope')
      //     .then((registration) => {
      //         registration.showNotification(message.notification.title);
      //     });

      this.currentMessage.next(message);
    });
    //
    this.fireMessaging.onBackgroundMessage((payload: any) => {
      console.log('payload in total closed state', payload);
      const clickAction = payload.data.url;

      // Handle notification click event
      // Navigate to a specific page in your PWA or perform other actions as necessary
      console.log('Notification clicked:', clickAction);
      window.open(clickAction, '_blank');
    });
  }
  checkurls(isAuthenticated) {

    const subPaths = this.router.url.split('/');
    const subPathSegment = subPaths[subPaths?.length - 2];
    console.log(subPathSegment);
    //     if(subPathSegment=='mfg'){
    //       if(isAuthenticated=='authenticated'){
    //         this.CheckGenieNavigation('authenticated');

    //       }
    //       else{
    // // now need to work on without login need to open login page after login open product items
    //       this.CheckGenieNavigation('not auth');

    //       }
    //     }
    // else if(subPathSegment=='ord'){
    //   const id = subPaths[subPaths?.length-1];
    //   if(isAuthenticated=='authenticated'){
    //     this.router.navigate([`shop/mach-orders/${id}`]);
    //   }
    //   else{
    //     this.router.navigate([`ord-login/${id}`]);
    //   }
    // }
    if (isAuthenticated == 'authenticated') {
      if (localStorage.getItem('genieId')) {
        this.dataService.setMachineId(parseInt(localStorage.getItem('genieId')));
        this.dataService.setFooterActie('shop');
        this.router.navigate(['shop/machine-prod-items']);
      }
      else {
        this.router.navigate(['shop/mfg-land']);
      }
    }
    else if (isAuthenticated == "not authenticated") {
      console.log('landscreennnn');
      this.router.navigate(['landscreen']);
    }
  }
  CheckGenieNavigation(isAuthenticated: string) {
    console.log('mfg');
    const fullUrl = this.router.url;
    const segments = fullUrl.split('/');
    const lastSegment = segments[segments?.length - 1];
    console.log('number', isNaN(Number(parseInt(lastSegment))));
    if (!isNaN(Number(parseInt(lastSegment)))) {
      // It's a number

      const machineObj = this.machinesList.find((mach) => mach.stallid == Number(lastSegment));
      if (machineObj) {
        this.dataService.setMachineId(machineObj.stallid);
        localStorage.setItem('genieId', machineObj.stallid + "");
        localStorage.setItem('genieName', machineObj.name);
        this.dataService.UpdateGenieName(machineObj.name);
        this.dataService.setGenieStatus(machineObj.cloudStatus);
        if (isAuthenticated == 'authenticated') this.router.navigate(['shop/machine-prod-items']);
        else {
          console.log('machinestallid', machineObj.stallid);
          this.router.navigate([`mfg-login/${machineObj.stallid}`]);
        }
      }
    } else {
      // It's a string
      console.log('anotherrrr')
      if (isAuthenticated == 'authenticated') this.router.navigate(['shop/mfg-land']);
      else this.router.navigate([`landscreen/0`]);
    }
  }
  async checkUser() {
    const endDate = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss', this.locale);
    console.log(endDate);
    const payload = {
      startDate: "2021-01-01 00:00:00",
      endDate: endDate
    }
    this.naviService.getUsersList(payload).subscribe((data) => {
      if (data) {
        this.loggeedUser$.subscribe((user) => {
          console.log(user);

          const usersList = data?.users;
          const isUser = usersList.find(obj => obj.email == user.email);
          if (isUser) {
            localStorage.setItem(
              'user',
              JSON.stringify({
                mobileNumber: isUser?.mobileNumber,
                accountId: isUser?.accountId,
                email: isUser?.email,
                userName: isUser?.name,
                role: isUser?.role
              })
            );
            if (user?.org_id) {
              localStorage.setItem('org_id', user?.org_id);
              localStorage.setItem('loginType', 'Corporate');
            }
            else {
              localStorage.setItem('loginType', 'Genie');
            }

            this.router.navigate(['shop/mfg-land']); // Replace '/other-page' with the desired route

          }
          else {
            // make payload
            this.userForm.get('mobileNumber').setValue(1234567890);
            this.userForm.get('email').setValue(user.email);
            this.userForm.get('fName').setValue(user.name);
            if (user?.org_id) {
              this.registerUser(user?.org_id);
            }
            else {
              const orgId = "";
              this.registerUser(orgId);
            }

          }

        })


      }
    })
  }
  registerUser(orgId: string) {

    const email = this.userForm.controls['email'].value;
    const mobileNumber = this.userForm.controls['mobileNumber'].value;
    const userName = this.userForm.controls['fName'].value;
    const userData: userprofile = {};

    userData.accountId = '0';
    userData.email = email; //this.user.email;
    userData.mobile = mobileNumber;
    userData.userName = userName;
    userData.password = "dummy";
    userData.mobileImei = '';
    userData.role = 'user';

    // console.log("userData: ", userData);
    this.naviService.registerUser(userData).subscribe((data) => {
      // this.closeModal();
      console.log(data);
      if (orgId == "") {
        localStorage.setItem('loginType', 'Genie');
      }
      else {
        localStorage.setItem('loginType', 'Corporate');
      }

      // localStorage.setItem('jwtToken', JSON.stringify(data.jwtToken));
      localStorage.setItem(
        'user',
        JSON.stringify({
          mobileNumber: data.mobile,
          accountId: data?.accountId,
          email: data?.email,
          userName: data?.userName,
          role: data?.role
        })
      );
      let cartItem: cart = {};
      cartItem = JSON.parse(localStorage.getItem('payload'));

      console.log('cart item:', cartItem);
      if (cartItem) {
        cartItem.accountId = data?.accountId;
        this.naviService.postCartItem(cartItem).subscribe((data) => {
          cartItem.cartId = data.cartId;
          localStorage.setItem('payload', JSON.stringify(cartItem));
          this.router.navigate(["shop/mfg-land"])
        });
      } else {
        this.router.navigate(["shop/mfg-land"])
      }
      //window.location.reload();
    });

  }
  installPwa(): void {
    this.Pwa.promptEvent.prompt();
  }
}
